var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { ICacheDataSourceType } from '../../DataSource/CacheDataSource/ICacheDataSource';
import { IAPIHTTPDataSourceType } from '../../DataSource/APIHTTPDataSource/IAPIHTTPDataSource';
import { StateMap } from './../../../Domain/DTOs/Module/ModuleDTO';
import { ILegacyAPIHTTPDataSourceType } from '../../DataSource/LegacyAPIHTTPDataSource/ILegacyAPIHTTPDataSource';
import { IStorageDataSourceType } from '../../DataSource/StorageDataSource/IStorageDataSource';
import { injectable } from '../../Decorators/Injectable';
import { inject } from '../../Decorators/Inject';
import { Observable } from '../../Observable/Observable';
let ProfileRepository = class ProfileRepository {
    constructor(cache, apiDataSource, legacyApiDataSource, storageDataSource) {
        this.cache = cache;
        this.apiDataSource = apiDataSource;
        this.legacyApiDataSource = legacyApiDataSource;
        this.storageDataSource = storageDataSource;
        this.profiles = new Observable([]);
        this.profile = new Observable('');
        this.images = {
            UKGoFantastic: require('./../../../Assets/Images/uk.png'),
            aus: require('./../../../Assets/Images/australia.png'),
            AUSGoFantastic: require('./../../../Assets/Images/australia.png')
        };
    }
    getProfileFromStorage() {
        return this.storageDataSource.get(StateMap.profile_keyword);
    }
    resetProfile() {
        return this.setProfileKeyword('');
    }
    setProfile(profile) {
        return this.setProfileKeyword(profile.keyword);
    }
    setProfileKeyword(profile) {
        this.storageDataSource.set(StateMap.profile_keyword, profile);
        this.apiDataSource.setProfile(profile);
        this.legacyApiDataSource.setProfile(profile);
        return this.profile.next(profile);
    }
    getProfiles() {
        return this.apiDataSource.get({ path: 'profiles' })
            .then(({ data }) => {
            const profiles = (data || []).map(profile => {
                profile.image_url = profile.image_url || this.images[profile.keyword];
                return profile;
            });
            return this.profiles.next(profiles);
        });
    }
    getCachedProfile() {
        return this.cache.getCache(StateMap.profile_keyword).data;
    }
    getProfile() {
        return this.profile;
    }
};
ProfileRepository = __decorate([
    injectable({ type: 'singleton' }),
    __param(0, inject(ICacheDataSourceType)),
    __param(1, inject(IAPIHTTPDataSourceType)),
    __param(2, inject(ILegacyAPIHTTPDataSourceType)),
    __param(3, inject(IStorageDataSourceType)),
    __metadata("design:paramtypes", [Object, Object, Object, Object])
], ProfileRepository);
export { ProfileRepository };
